import { Link } from 'react-router-dom';

export const NotFoundPage = () => {
  return (
    <div
      className="flex min-h-[70vh] flex-col items-center justify-center text-center"
      style={{ padding: 'var(--space-4)' }}
    >
      <h1
        style={{
          fontSize: 'var(--text-hero)',
          fontWeight: 'var(--font-weight-bold)',
          color: 'var(--text-primary)',
          letterSpacing: 'var(--tracking-tight)',
        }}
      >
        404
      </h1>
      <p
        style={{
          marginTop: 'var(--space-4)',
          fontSize: 'var(--text-lg)',
          color: 'var(--text-secondary)',
        }}
      >
        Page not found
      </p>
      <Link
        to="/"
        className="focus-ring"
        style={{
          marginTop: 'var(--space-6)',
          backgroundColor: 'var(--color-primary-600)',
          color: 'var(--text-inverse)',
          padding: 'var(--space-3) var(--space-6)',
          borderRadius: 'var(--radius-lg)',
          fontWeight: 'var(--font-weight-medium)',
          textDecoration: 'none',
          transition: `background-color var(--duration-fast) var(--ease-out)`,
        }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-primary-500)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-primary-600)'; }}
      >
        Back to Home
      </Link>
    </div>
  );
};
